// https://github.com/vercel/next.js/discussions/11484#discussioncomment-60563
export const parseQueryParams = (path: string, key: string) => {
  // if string is valid result will be like: ['?key=value', 'value']
  const result = path.match(new RegExp(`${key}=([^&]*)`));

  const value = result !== null && result.length > 1 ? result[1] : null;

  return value || null;
};
